import { action } from 'mobx';

const lightPalette = {
    mode: 'light' as const,
    background: {
        default: '#f5f6fa',
        paper: '#ffffff',
    },
    text: {
        primary: '#0D2067',
        secondary: '#5B74CF',
    },
    primary: {
        light: '#5B74CF',
        main: '#28419e',
        dark: '#0D2067',
    },
    secondary: {
        light: '#9DE3E3',
        main: '#57c7c5',
        dark: '#1C8181',
    },
    error: {
        light: '#ef5350',
        main: '#d32f2f',
        dark: '#c62828',
    },
    warning: {
        light: '#ff9800',
        main: '#ed6c02',
        dark: '#e65100',
    },
    action: { active: '#5B74CF' },
    info: {
        light: '#03a9f4',
        main: '#0288d1',
        dark: '#01579b',
    },
    success: {
        light: '#4caf50',
        main: '#2e7d32',
        dark: '#1b5e20',
    },
    sidebar: {
        main: '#f8f8fa',
    },
};

export default lightPalette;
